import { parseDimensionValue } from "./popup-step-sections";

/** Matches AI builder + template defaults for icon-only close controls. */
export const ICON_CLOSE_SIZE_CAP = {
  desktop: 32,
  mobile: 28,
};

export function isIconCloseButton(section) {
  if (section?.type !== "BUTTON") return false;
  if (String(section?.setting?.btn_type?.type || "").toLowerCase() !== "icon") {
    return false;
  }
  return String(section?.setting?.action?.type || "").toLowerCase() === "close_popup";
}

/**
 * Live/preview layout for icon close buttons saved with oversized draggable boxes.
 * Keeps the top-right anchor by shifting x when width is clamped.
 * Returns null when no adjustment is needed.
 */
export function resolveIconCloseButtonLayout(section, isMobile) {
  if (!isIconCloseButton(section)) return null;

  const view = isMobile ? "mobile" : "desktop";
  const cap = ICON_CLOSE_SIZE_CAP[view];
  const dim = section?.setting?.dimension?.[view];
  const pos = section?.setting?.position?.displacement?.[view];

  const width = parseDimensionValue(dim?.width) || cap;
  const height = parseDimensionValue(dim?.height) || cap;

  if (width <= cap && height <= cap) return null;

  const nextWidth = Math.min(width, cap);
  const nextHeight = Math.min(height, cap);
  const x = parseDimensionValue(pos?.x) || 0;
  const y = parseDimensionValue(pos?.y) || 0;

  return {
    dimension: { width: nextWidth, height: nextHeight },
    displacement: {
      x: x + (width - nextWidth),
      y,
    },
  };
}
